import { Prec } from "@codemirror/state";
import { EditorView, keymap } from "@codemirror/view";

export function buildEditorSelectionInfo(view) {
    const mainSelection = view.state.selection.main;
    const head = mainSelection.head;
    const anchor = mainSelection.anchor;
    const line = view.state.doc.lineAt(head);
    const from = Math.min(anchor, head);
    const to = Math.max(anchor, head);
    const startLine = view.state.doc.lineAt(from);
    const endLine = view.state.doc.lineAt(to);

    return {
        line: line.number,
        column: head - line.from + 1,
        from,
        to,
        hasSelection: from !== to,
        startLine: startLine.number,
        startColumn: from - startLine.from + 1,
        endLine: endLine.number,
        endColumn: to - endLine.from + 1,
        selectedText: from !== to ? view.state.sliceDoc(from, to) : "",
    };
}

function openSelectionActionMenuAtSelection(view, onOpenSelectionActionMenu) {
    const selectionInfo = buildEditorSelectionInfo(view);
    if (!selectionInfo.hasSelection) {
        return false;
    }

    const coords = view.coordsAtPos(view.state.selection.main.head);
    if (!coords) {
        return false;
    }

    onOpenSelectionActionMenu?.({
        top: coords.top,
        left: coords.left,
        selection: selectionInfo,
    });
    return true;
}

export function selectionActionContextMenu(onOpenSelectionActionMenu) {
    if (!onOpenSelectionActionMenu) {
        return [];
    }

    return [
        EditorView.domEventHandlers({
            contextmenu(event, view) {
                const selectionInfo = buildEditorSelectionInfo(view);
                if (!selectionInfo.hasSelection) {
                    return false;
                }

                event.preventDefault();
                onOpenSelectionActionMenu({
                    top: event.clientY,
                    left: event.clientX,
                    selection: selectionInfo,
                });
                return true;
            },
            mousedown(event, view) {
                if (event.button !== 2) {
                    return false;
                }

                const selectionInfo = buildEditorSelectionInfo(view);
                if (!selectionInfo.hasSelection) {
                    return false;
                }

                // Preserve the current selection on right-click, matching the
                // editor-first interaction model used by Overleaf.
                event.preventDefault();
                return true;
            },
        }),
        Prec.high(
            keymap.of([
                {
                    key: "Shift-F10",
                    run: (view) => openSelectionActionMenuAtSelection(view, onOpenSelectionActionMenu),
                },
                {
                    key: "ContextMenu",
                    run: (view) => openSelectionActionMenuAtSelection(view, onOpenSelectionActionMenu),
                },
            ]),
        ),
    ];
}
